import { createAction } from 'react-async-client';

import {
    APP_RUN,
    CHANGE_LANGUAGE,
    SET_HEADER_TITLE,
    PIN_LEFT_MENU,
    COLLAPSE_LEFT_MENU,
    ALLOW_NOTIFICATION_PERMISSION,
    LOCATION_CHANGE,
    COLOR_SCHEME_CHANGE,
} from '../constants/actionTypes';

export const appRun = createAction(APP_RUN);
export const locationChange = createAction(LOCATION_CHANGE);
export const changeLanguage = createAction(CHANGE_LANGUAGE);
export const setHeaderTitle = createAction(SET_HEADER_TITLE);
export const pinLeftMenu = createAction(PIN_LEFT_MENU);
export const collapseLeftMenu = createAction(COLLAPSE_LEFT_MENU);
export const changeColorScheme = createAction(COLOR_SCHEME_CHANGE);

export const allowNotificationPermission = createAction(ALLOW_NOTIFICATION_PERMISSION);
